import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectSearchInstruments } from '!core/redux/userInstruments/userInstruments.selectors';
import { TrlSearch } from '»components/atoms';
import { TrlInsertOrderModal } from '»components/templates/TrlInsertOrder/TrlInsertOrderModal';

import { TrlFormattedMessagePlain } from '../../../utils/i18n';
import { TrlLeftSlot, TrlRightSlot } from './Slots';
import { SearchButton, SearchIcon } from './TrlSearchBar.styles';

export const TrlSearchBar = ({ open }) => {
  const [isOpen, setisOpen] = useState(open);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('xl'));

  const searchableInstruments = useSelector(selectSearchInstruments);
  const [selectedOption, setSelectedOption] = useState({ exchange: null });

  return (
    <>
      <TrlInsertOrderModal titleInfo={selectedOption} />
      <SearchButton
        id="btnSearch"
        isOpen={isOpen}
        onClick={() => setisOpen(!isOpen)}
      >
        <SearchIcon icon={faSearch} />
      </SearchButton>
      {(isOpen || matches) && (
        <TrlSearch
          id="txbSearch"
          options={searchableInstruments}
          placeholder={TrlFormattedMessagePlain({
            id: 'TRLT_UI-NAME_ISIN_SYMBOL',
          })}
          hasCustomPopper
          renderLeftSlot={(option) => <TrlLeftSlot option={option} />}
          renderRightSlot={(option) => (
            <TrlRightSlot
              option={option}
              setSelectedOption={setSelectedOption}
            />
          )}
          paperId={'divInstruments'}
          uppercaseLetters
        />
      )}
    </>
  );
};

TrlSearchBar.propTypes = {
  options: PropTypes.array,
  open: PropTypes.bool,
};
